import { firestore } from "@/api/firebase/firebase.config";

export async function _updateFirebaseDoc(
  collectionName: string,
  docId: string,
  data: Record<string, any>
) {
  console.log(collectionName, docId, data);

  await firestore
    .collection(collectionName)
    .doc(docId)
    .update({
      ...data,
    });
}
